import { ctw } from '@/common';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms';

export const QuestionMarkTooltip: React.FC<{ text: string; className?: string }> = ({
  text,
  className,
}) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={ctw(
            'cursor-help rounded-full text-stone-300 bg-zinc-100 text-xs w-4 h-4 flex items-center justify-center font-medium',
            className,
          )}
        >
          ?
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p className="text-sm">{text}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
